module.exports = __webpack_public_path__ + "static/img/intervi-6.e7b02d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/persons/intervi-6.jpg
// module id = mH/K
// module chunks = 0